<template>
  <div class="source-wrap" v-loading="loading">
    <!--<el-button type="primary" size="small" @click="drawer = !drawer">{{$t('feed.settings.stopSource.sourceButton')}}</el-button>-->
    <el-divider></el-divider>

    <ul class="source-list" v-if="sources.length">
      <li class="source-list__item" v-for="(source, index) in sources" :key="index">
        <div class="source-list__item-delete" @click="deleteSource(source)">
          <i class="el-icon-close"></i>
        </div>
        <div class="pseudo-link-wrap" @click="goToLink(source)">
          <el-avatar :src="source.image" size="large"></el-avatar>
        </div>
        <div class="network-name">
          <img src="../../../../../assets/img/vk-icon.svg" width="16px" v-if="source.network_name === 'vk'">
          <img src="../../../../../assets/img/ok-icon.svg" width="16px" v-if="source.network_name === 'ok'">
          <img src="../../../../../assets/img/yt.png" width="16px" v-if="source.network_name === 'yt'">
          <img src="../../../../../assets/img/twitter.svg" width="16px" v-if="source.network_name === 'tw'">
          <img src="../../../../../assets/img/telegram.svg" width="16px" v-if="source.network_name === 'tg'">
          <img src="../../../../../assets/img/facebook.svg" width="16px" v-if="source.network_name === 'fb'">
          <img src="../../../../../assets/img/gs.svg" width="16px" v-if="source.network_name === 'gs'">
        </div>
      </li>
    </ul>
    <ul class="source-list" v-else>
      <template v-if="isLoaded">
        <li>
          {{$t('feed.settings.stopSource.empty')}}.
        </li>
      </template>
      <template v-else>
        <li class="source-list__item" v-for="item in limit" :key="item">
          <el-avatar  src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" size="large"></el-avatar>
        </li>
      </template>
    </ul>

    <el-drawer
      custom-class="source-drawer"
      :visible.sync="drawer"
      :direction="direction"
      size="100%"
      :append-to-body="true"
    >
      <new-stop-source @updateSources="updateSources" />
    </el-drawer>
  </div>
</template>

<script>
  /*
    Stop source component
  */

  // api
  import { getStopSourcesApi, deleteStopSourceApi } from "../../../../../api/feeds";

  // components
  import notify from "../../../../../helpers/notify";
  import NewStopSource from './components/NewStopSource';

  export default {
    name: "StopSource",
    props: {
      active: {
        type: Boolean
      },
    },
    data() {
      return {
        loading: false,
        isLoaded: false,
        sources: [],
        offset: 0,
        limit: 120,
        drawer: false,
        direction: 'rtl',
      };
    },
    methods: {
      updateSources(data) {
        this.sources.push({
          username: data.name,
          image: data.image,
          id: data.id,
          profile_id: data.profile_id
        });

        this.drawer = !this.drawer;
      },
      goToLink(source) {
        window.open(source.url, '_blank');
      },
      deleteSource(source) {
        let username = source.username;
        let network = source.network_id;
        let source_id = source.profile_id;
        this.$alert(`Удалить минус-источник ${username}?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.handleDelete(source_id, network);
            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      handleDelete(source_id, network) {
            let params = {
              thread_id: this.$route.params.threadId,
              profile_id: source_id,
              network_id: network,
            };

        this.loading = true;

        deleteStopSourceApi(params).then(() => {
          this.loading = false;
          this.sources = this.sources.filter(item => item.profile_id !== source_id);
          notify.call(this, `Минус-источник удален`, "success");
        });
      },
      getSources() {
        let params = {
          thread_id: this.$route.params.threadId,
          offset: this.offset,
          limit: this.limit,
        };
        this.loading = true;
        getStopSourcesApi(params).then((resp) => {
          this.sources = [...this.sources, ...resp.data.items];
          this.offset = this.sources.length;
          this.loading = false;
          this.isLoaded = true;
        });
      }
    },
    watch: {
      active(value) {
        if (value) {
          if (!this.sources.length) {
            this.getSources();
          }
        }
      }
    },
    components: {
      NewStopSource,
    }
  };
</script>
